import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { firstValueFrom, take } from 'rxjs';
import { HistoryService } from '@agenda-customer-ui/data-access';
import { SharedModuleLib } from '../../../../../shared.module';
import { NgIf, NgFor, UpperCasePipe } from '@angular/common';
import { NoContentComponent } from '../no-content/no-content.component';
import { CardHistoryComponent } from '../../../card/card.component';
import { formattedDateDefault, getDayOfWeek, parseDateWithWeek } from '@core/utils';
import { RevisionHistory, revisionPartVOs } from 'libs/core/src/interfaces/from-history/models';
import { AccordionLibComponent, TableComponent, TableElement } from '@components/atoms';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-revision',
    templateUrl: './revision.component.html',
    styleUrls: ['./revision.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        NgIf,
      SharedModuleLib,
        NoContentComponent,
        NgFor,
        AccordionLibComponent,
        CardHistoryComponent,
        TableComponent,
        UpperCasePipe,
        TranslateModule,
    ],
})
export class RevisionComponent implements OnInit {
  @Input() vin!: string;
  @Input() country!: string;

  serviceHistory?: RevisionHistory[] = [];
  revisionParts: revisionPartVOs[] = [];

  revisionLoaded = true;

  constructor(
    private historyService: HistoryService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.getRevision();
  }

  getPartsElements(parts: revisionPartVOs[]): TableElement[] {
    return (parts || []).map((part, index) => ({
      id: index,
      name: part.longDescription,
      description: '',
    }));
  }

  getRevision() {
    this.revisionLoaded = false;
    this.historyService
      .getRevisionHistory(this.vin, this.country)
      .pipe(take(1))
      .subscribe({
        next: (history) => {
          this.serviceHistory = history;
          this.sortByLatestDate(this.serviceHistory);
          this.addDateToList();
          this.trimServiceName(this.serviceHistory);
        },
        error: () => {
          this.revisionLoaded = true;
        }
      });
  }

  parseDate(date: string, hour: number | null, minutes: number | null) {
    const newDate = new Date(date + 'T00:00:00');
    const dayOfWeek = getDayOfWeek(
      newDate.getDay(),
      this.country
    );
    return parseDateWithWeek(newDate, dayOfWeek, hour, minutes);
  }

  trimServiceName(history: RevisionHistory[]) {
    for(let i = 0; i < history.length; i++) {
      history[i].revisionName = history[i].revisionName.split("–")[0]
      history[i].revisionName = history[i].revisionName.split("-")[0]
    }
  }

  addDateToList() {
    this.serviceHistory?.forEach((history) => {
      // TODO ajustar isso para receber a hora correta que está no banco hoje está vindo como 0, lembrar de trocar o createDate que NÃO é o dado correto
      const hour: number | null =
        history.createDate && history.createDate !== null
          ? new Date(history.createDate).getHours()
          : null;

      const minutes: number | null =
        history.createDate && history.createDate !== null
          ? new Date(history.createDate).getMinutes()
          : null;
      history.formattedRevisionDate = this.parseDate(
        history.revisionDate,
        hour,
        minutes
      );
      history.revisionDate = formattedDateDefault(history.revisionDate);
      this.creatServicesPerformed(history);
    });
    this.revisionLoaded = true;
  }

  sortByLatestDate(history: RevisionHistory[]) {
    history.sort(
      (a, b) =>
        new Date(b.revisionDate).getTime() - new Date(a.revisionDate).getTime()
    );
  }

  public createPhraseKm(km: number): string {
    return km ? ` - ${km} km ` : '';
  }

  public createPhraseMonths(months: number): string {
    months = months / 12;
    return months ? `${this.translateService.instant('common.or')} ${months} ${this.translateService.instant('common.year')}${months === 1 ? '' : 's'}` : '';
  }

  private async creatServicesPerformed(history: RevisionHistory): Promise<void> {
    if ( history.months ) {
      const data = await firstValueFrom(this.historyService.getRevision(history.months, this.vin, this.country));
      history.parts = data.response[0]?.revisionPartVOs.filter(item => item.longDescription !== null);
    }
  }
}
